import { render, staticRenderFns } from "./Guess.vue?vue&type=template&id=05fa1501&scoped=true&"
import script from "./Guess.vue?vue&type=script&lang=js&"
export * from "./Guess.vue?vue&type=script&lang=js&"
import style0 from "./Guess.vue?vue&type=style&index=0&id=05fa1501&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa1501",
  null
  
)

export default component.exports